<template>
  <div class="container fluid">
    <template>
      <div class="mb-2">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm12 class="text-xs-right">
            <div class="text-xs-right">
              <exportxlsx :promised-value="getXlsxData"></exportxlsx>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-2">
        <date-filter
          v-model="selectedDate"
          :default-filter="'last_7_days'"
          @changeDate="onChangeDate"
        ></date-filter>
      </div>
      <div class="mb-2">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm12 class="text-xs-right">
            <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>ค้นหา</v-btn>
          </v-flex>
          <v-flex xs12 sm9>
            <div>
              <v-pagination
                v-model="pageNumber"
                :total-visible="6"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
          </v-flex>

          <v-flex xs12 sm3 class="text-xs-right primary--text pt-4" style="font-weight: 700">
            Total : {{ total }}
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        :headers="headers"
        :items="dataMembership"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
        :search="search"
      >
        <!-- hide-actions -->
        <template #items="props">
          <tr style="cursor: pointer" @click="showMembershipDetails(props.item)">
            <td>{{ props.item.name }}</td>
            <td class="text-center">{{ props.item.member_type }}</td>
            <td class="text-center">{{ props.item.total_purchase | numberFormat }}</td>
            <td class="text-center">{{ props.item.next_tier | numberFormat }}</td>
            <td class="text-center">{{ getDateFormatted(props.item.expired_timestamp) }}</td>
            <td class="text-center">
              {{ props.item.renew_timestamp ? getDateFormatted(props.item.renew_timestamp) : '-' }}
            </td>
            <td class="text-center">{{ props.item.pdpa ? 'Agree' : 'Disagree' }}</td>
            <!-- <td class="text-center">
              <a href="javascript:void(0);" @click="showMembershipDetails(props.item)" >
                <span class="primary--text">รายละเอียด</span>
              </a>
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="mt-2">
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </div>

    <!-- Modal Search -->
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('ชื่อ-สกุล') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('ประเภทสมาชิก') }}</label>
                <!-- <input v-model="filter.member_type" class="form-control" type="text" /> -->
                <Multiselect
                  v-model="filter.member_type"
                  placeholder="เลือกประเภทสมาชิก"
                  :options="memberTypeData"
                  label="text"
                  @input="$emit('change', $event)"
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('วันที่หมดอายุสมาชิก') }}</label>
                <DatePickerWithoutButton v-model="filter.expired_timestamp">
                  <input
                    readonly
                    :value="getDateFormatted(filter.expired_timestamp)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('วันที่ต่ออายุสมาชิก') }}</label>
                <DatePickerWithoutButton v-model="filter.renew_timestamp">
                  <input
                    readonly
                    :value="getDateFormatted(filter.renew_timestamp)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal Warranty Details -->
    <v-dialog v-model="membershipDetailsModal" persistent width="950px">
      <v-card v-if="membershipDetailsModal">
        <MembershipDetails
          :member-data="selectMemberData"
          @close="membershipDetailsModal = false"
        ></MembershipDetails>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import MembershipDetails from './MembershipDetails.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    MembershipDetails,
    ScaleLoader,
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    Multiselect
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'ชื่อลูกค้า', value: 'name', width: '5%', sortable: false },
        { text: 'ประเภทสมาชิก', value: 'memberType', width: '2%', sortable: false },
        { text: 'ยอดซื้อทั้งหมด', value: 'totalPurchase', width: '2%', sortable: false },
        {
          text: 'คะแนนคงเหลือเพื่อเลื่อนระดับสมาชิก',
          value: 'next_tier',
          width: '2%',
          sortable: false
        },
        { text: 'วันหมดอายุ', value: 'expiredDate', width: '2%', sortable: false },
        { text: 'วันที่ต่ออายุ', value: 'renewDate', width: '2%', sortable: false },
        { text: 'PDPA', value: 'pdpa', width: '2%', sortable: false }
        // { text: '', value: '', width: '3%', sortable: false },
      ],
      dataMembership: [],
      loading: false,
      orderModal: false,
      search: '',
      filter: {
        name: '',
        member_type: '',
        register_timestamp: '',
        expired_timestamp: '',
        renew_timestamp: ''
      },
      membershipDetailsModal: false,
      selectMemberData: null,
      showsearch: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      memberTypeData: [{ text: 'new' }, { text: 'silver' }, { text: 'gold' }],
      isExport: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    pageid() {
      return this.selectedBot.pageid
    }
  },
  mounted() {
    var vm = this
    vm.getMembership()
  },

  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getMembership()
        this.isExport = false
        this.getMembership()

        resolve(
          data.map((el) => {
            return {
              ชื่อลูกค้า: el.name,
              'วัน เดือน ปีเกิด': el.dob ? moment(el.dob).format('DD/MM/YYYY') : '',
              เพศ: el.gender,
              อายุ: el.ages,
              อีเมล: el.email,
              เบอร์โทรศัพท์: el.phone_number,
              ประเภทสมาชิก: el.member_type,
              ยอดซื้อทั้งหมด: el.total_purchase,
              คะแนนคงเหลือเพื่อเลื่อนระดับสมาชิก: el.next_tier,
              วันหมดอายุสมาชิก: el.expired_timestamp
                ? moment(el.expired_timestamp).format('DD/MM/YYYY')
                : '',
              วันที่ต่ออายุสมาชิก: el.renew_timestamp
                ? moment(el.renew_timestamp).format('DD/MM/YYYY')
                : '',
              PDPA: el.pdpa ? 'Agree' : 'Disagree'
            }
          })
        )

        this.isExport = false
        this.limit = 10
      })
    },
    getMembership() {
      return new Promise((resolve) => {
        var vm = this
        var limit = ''

        if (this.isExport) {
          limit = this.total
        } else {
          limit = vm.limit
        }

        var data = {
          pageid: vm.pageid, // required
          limit: limit, // required
          offset: vm.offset, // required
          name: vm.filter.name,
          gender: '',
          phone_number: '',
          email: '',
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          expired_timestamp: vm.filter.expired_timestamp,
          renew_timestamp: vm.filter.renew_timestamp
        }

        if (vm.filter.member_type) {
          Object.assign(data, { member_type: vm.filter.member_type.text })
        }

        vm.loading = true
        api.getLamyMembership(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataMembership = response.data
            vm.total = response.total
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    showMembershipDetails(item) {
      var vm = this
      vm.selectMemberData = item
      vm.membershipDetailsModal = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getMembership()
      }
    },
    onsearch() {
      this.offset = 0
      this.pageNumber = 1
      this.getMembership()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        member_type: '',
        register_timestamp: '',
        expired_timestamp: '',
        renew_timestamp: ''
      }
      this.onsearch()
    },
    onChangeDate() {
      this.onsearch()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/MembershipOverview.vue